import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Quotes"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9 11.25H4.5825C4.86434 9.3731 5.92334 7.70157 7.5 6.645L8.8425 5.745L8.0175 4.5L6.675 5.4C4.37994 6.92942 3.00092 9.50452 3 12.2625V17.25C3 18.0784 3.67157 18.75 4.5 18.75H9C9.82843 18.75 10.5 18.0784 10.5 17.25V12.75C10.5 11.9216 9.82843 11.25 9 11.25ZM19.5 11.25H15.0825C15.3643 9.3731 16.4233 7.70157 18 6.645L19.3425 5.745L18.525 4.5L17.175 5.4C14.8799 6.92942 13.5009 9.50452 13.5 12.2625V17.25C13.5 18.0784 14.1716 18.75 15 18.75H19.5C20.3284 18.75 21 18.0784 21 17.25V12.75C21 11.9216 20.3284 11.25 19.5 11.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Quotes.vue"]]);
